<template>
    <div class="bar-space">
            <!--        下面一行临时在h5修复在ios上状态栏透明问题-->
        <div style="position: fixed;width: 100%;height: 50px;top: -49px;z-index: 100;background-color: #fff"></div>
        <div class="title-bar">
            <div class="left" v-if="isClient" @click="returnEvent">
                <img src="./img/left.png" alt="">
            </div>
            <div class="left" v-else></div>
            <div class="center van-ellipsis">
                <slot></slot>
            </div>
            <div class="right">
                <slot name="right" v-if="isClient"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import {isClient} from '@/utils/isTerminal.js'
    import { backNative } from '@/utils/JSBridge.js'
    import { Toast } from 'vant'

    export default {
        name: 'TitleBar',
        props: {
            returnEvent:{
                type:Function,
                default:_=>{
                    backNative({goback_add: 'back'});//直接返回
                },
            },
        },
        data: function () {
            return {
                isClient: isClient,
            }
        },
        components: { Toast }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .bar-space {
        width: 100%;
        height: 44px;

        .title-bar {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            z-index: 50;
            background: #fff;
            display: flex;
            height: 44px;
            overflow: hidden;

            .left {
                display: flex;
                align-items: center;
                height: 100%;
                width: 80px;

                img {
                    margin-left: 12px;
                    width: 10px;
                    height: 18px;
                }
            }

            .center {
                flex: 1;
                display: flex;
                height: 100%;
                justify-content: center;
                align-items: center;
                font-size: 17px;
                color: #222222;
            }

            .right {
                width: 80px;
                overflow: hidden;
                height: 100%;
                display: flex;
                margin-right: 12px;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

</style>
